<template>
  <v-layout wrap>
    <v-flex v-if="Object.keys(eleitorGetter).length > 0">
      <v-layout
        v-if="eleitorGetter.anexos && eleitorGetter.anexos.length"
        wrap
        align-center
      >
        <v-flex>
          <v-avatar tile size="120">
            <img :src="`data:${eleitorGetter.anexos[0].no_mime_type};base64,${eleitorGetter.anexos[0].arquivoCodificado}`" />
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-layout
        v-else-if="eleitorGetter.arquivos && eleitorGetter.arquivos.length"
        wrap
        align-center
      >
        <v-flex>
          <v-avatar tile size="120">
            <img :src="eleitorGetter.arquivos[0].ds_localizacao" />
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.nu_cpf"
            disabled
            label="CPF"
            append-icon="account_circle"
            mask="###.###.###-##"
          />
        </v-flex>
      </v-layout>
      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.no_nome"
            disabled
            label="Nome completo"
            append-icon="perm_identity"
          />
        </v-flex>
      </v-layout>
      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.nu_rg"
            disabled
            label="RG"
            append-icon="account_circle"
            mask="#########"
          />
        </v-flex>
      </v-layout>
      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.nu_telefone"
            label="Celular do eleitor"
            append-icon="phone"
            mask="(##) #####-####"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.dt_nascimento"
            disabled
            label="Data de Nascimento"
            append-icon="event"
            mask="##/##/####"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-text-field
            v-model="eleitorGetter.ds_email"
            disabled
            label="E-mail"
            append-icon="mail"
            placeholder="email@exemplo.com"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
      >
        <v-flex>
          <v-select
            v-model="eleitorGetter.st_estrangeiro"
            :items="[{ st_estrangeiro: '0' , nome: 'Brasileiro'},
                     { st_estrangeiro: '1' , nome: 'Outros'}]"
            item-value="st_estrangeiro"
            item-text="nome"
            label="Nacionalidade"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>
       <v-layout>
        <v-flex>
          <v-text-field
            v-model="(eleitor.endereco || {}).nu_cep"
            label="CEP"
            append-icon="my_location"
            mask="#####-###"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(eleitor.endereco || {}).ds_logradouro"
            label="Logradouro"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-text-field
            v-model="(eleitor.endereco || {}).ds_complemento"
            label="Complemento"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

       <v-layout>
        <v-flex>
          <v-text-field
            v-model="(eleitor.endereco || {}).no_bairro"
            label="Bairro"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-select
            v-model="(eleitor.endereco || {}).co_ibge"
            :items="listaUF"
            label="UF"
            item-value="co_ibge"
            item-text="no_uf"
            append-icon="place"
            disabled
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-select
            v-model="(eleitor.endereco || {}).co_municipio"
            :items="listaMunicipios"
            label="Cidade"
            append-icon="place"
            item-value="co_municipio"
            item-text="no_municipio"
            disabled
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EleitorDetalhesInscricaoVisualizacao',
  data: () => ({
    listaUF: [],
    listaMunicipios: [],
    eleitor: {},
  }),
  // props: {
  //   value: {
  //     type: Boolean,
  //     default: true,
  //   },
  // },
  computed: {
    ...mapGetters({
      eleitorGetter: 'eleitor/eleitor',
      estadosGetter: 'localidade/estados',
      municipiosGetter: 'localidade/municipios',
    }),
  },
  watch: {
    eleitorGetter(value) {
      this.eleitor = value;
      if (this.listaMunicipios.length < 1 && Object.keys(this.eleitorGetter).length > 0) {
        this.obterMunicipios(value.endereco.co_ibge);
      }
    },
    estadosGetter() {
      this.listaUF = this.estadosGetter;
    },
  },
  mounted() {
    this.listaUF = this.estadosGetter;
    if (this.listaUF.length < 1) {
      this.obterEstados();
    }
    this.eleitor = this.eleitorGetter;
    this.listaMunicipios = this.municipiosGetter;
  },
  methods: {
    formatarDataCarbon(data) {
      if (data.length === 0 || !data.trim()) {
        return false;
      }
      const [dia, mes, ano] = data.split('/');

      return `${ano}-${(`0${mes}`).slice(-2)}-${(`0${dia}`).slice(-2)}`;
    },
    ...mapActions({
      obterEstados: 'localidade/obterEstados',
      obterMunicipios: 'localidade/obterMunicipios',
    }),
  },

};
</script>
